<template>
	<svg :width="width" :height="height" :viewBox="viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_324_716)">
			<path d="M13.3972 8H17.84C18.2597 8 18.6 8.34026 18.6 8.76V12.8068C18.6 14.3494 17.3494 15.6 15.8068 15.6H15.7936C14.251 15.6002 13.0002 14.3498 13 12.8072C13 12.8071 13 12.8069 13 12.8068V8.3972C13 8.17783 13.1778 8 13.3972 8Z" fill="#5059C9"/>
			<path d="M16.4 7.19999C17.3941 7.19999 18.2 6.3941 18.2 5.39999C18.2 4.40588 17.3941 3.59999 16.4 3.59999C15.4059 3.59999 14.6 4.40588 14.6 5.39999C14.6 6.3941 15.4059 7.19999 16.4 7.19999Z" fill="#5059C9"/>
			<path d="M10.8 7.20001C12.236 7.20001 13.4 6.03594 13.4 4.6C13.4 3.16406 12.236 2 10.8 2C9.36407 2 8.20001 3.16406 8.20001 4.6C8.20001 6.03594 9.36407 7.20001 10.8 7.20001Z" fill="#7B83EB"/>
			<path d="M14.2668 8H6.93323C6.5185 8.01026 6.19041 8.35445 6.20004 8.7692V13.3848C6.14212 15.8737 8.11122 17.9391 10.6 18C13.0889 17.9391 15.058 15.8737 15 13.3848V8.7692C15.0097 8.35445 14.6816 8.01026 14.2668 8Z" fill="#7B83EB"/>
			<path opacity="0.1" d="M11 8V14.468C10.9981 14.7646 10.8183 15.0311 10.544 15.144C10.4567 15.1809 10.3629 15.2 10.268 15.2H6.55204C6.50004 15.068 6.45204 14.936 6.41204 14.8C6.27202 14.341 6.20058 13.8639 6.20004 13.384V8.768C6.19042 8.35391 6.51796 8.01026 6.93204 8H11Z" fill="black"/>
			<path opacity="0.2" d="M10.6 8V14.868C10.6 14.9628 10.581 15.0567 10.544 15.144C10.4311 15.4183 10.1647 15.598 9.86805 15.6H6.74004C6.67204 15.468 6.60804 15.336 6.55204 15.2C6.49604 15.064 6.45204 14.936 6.41204 14.8C6.27202 14.341 6.20058 13.8639 6.20004 13.384V8.768C6.19042 8.35391 6.51796 8.01026 6.93204 8H10.6Z" fill="black"/>
			<path opacity="0.2" d="M10.6 8V14.068C10.597 14.471 10.271 14.797 9.86804 14.8H6.41204C6.27202 14.341 6.20058 13.8639 6.20004 13.384V8.768C6.19042 8.35391 6.51796 8.01026 6.93204 8H10.6Z" fill="black"/>
			<path opacity="0.2" d="M10.2 8V14.068C10.197 14.471 9.87104 14.797 9.46803 14.8H6.41204C6.27202 14.341 6.20058 13.8639 6.20004 13.384V8.768C6.19042 8.35391 6.51796 8.01026 6.93204 8H10.2Z" fill="black"/>
			<path opacity="0.1" d="M11 5.932V7.192C10.932 7.196 10.868 7.20001 10.8 7.20001C10.732 7.20001 10.668 7.19601 10.6 7.192C10.465 7.18305 10.3311 7.16162 10.2 7.12801C9.39003 6.93619 8.72084 6.36812 8.40004 5.60001C8.34484 5.47102 8.30198 5.33708 8.27203 5.20001H10.268C10.6717 5.20154 10.9985 5.52836 11 5.932Z" fill="black"/>
			<path opacity="0.2" d="M10.6 6.332V7.192C10.465 7.18304 10.3311 7.16162 10.2 7.128C9.39002 6.93618 8.72083 6.36811 8.40002 5.60001H9.86802C10.2717 5.60153 10.5985 5.92837 10.6 6.332Z" fill="black"/>
			<path opacity="0.2" d="M10.6 6.332V7.192C10.465 7.18304 10.3311 7.16162 10.2 7.128C9.39002 6.93618 8.72083 6.36811 8.40002 5.60001H9.86802C10.2717 5.60153 10.5985 5.92837 10.6 6.332Z" fill="black"/>
			<path opacity="0.2" d="M10.2 6.33201V7.128C9.39002 6.93618 8.72083 6.36811 8.40002 5.60001H9.46802C9.87166 5.60154 10.1985 5.92837 10.2 6.33201Z" fill="black"/>
			<path d="M2.13322 5.60001H9.46682C9.87176 5.60001 10.2 5.92827 10.2 6.3332V13.6668C10.2 14.0717 9.87175 14.4 9.46682 14.4H2.13322C1.72828 14.4 1.40002 14.0717 1.40002 13.6668V6.3332C1.40002 5.92827 1.72829 5.60001 2.13322 5.60001Z" fill="url(#paint0_linear_324_716)"/>
			<path d="M7.72962 8.3912H6.26362V12.3832H5.32962V8.3912H3.87042V7.61681H7.72962V8.3912Z" fill="white"/>
		</g>
		<defs>
			<linearGradient id="paint0_linear_324_716" x1="2.92876" y1="5.0271" x2="8.67129" y2="14.9729" gradientUnits="userSpaceOnUse">
				<stop stop-color="#5A62C3"/>
				<stop offset="0.5" stop-color="#4D55BD"/>
				<stop offset="1" stop-color="#3940AB"/>
			</linearGradient>
			<clipPath id="clip0_324_716">
				<rect width="17.2" height="16" fill="white" transform="translate(1.40002 2)"/>
			</clipPath>
		</defs>
	</svg>

</template>

<script>

export default {
	name: "MicrosoftTeamsIcon",
	props: {
		width: {
			type: Number,
			default: 20,
		},
		height: {
			type: Number,
			default: 20,
		},
	},
	computed: {
		viewBox() {
			const { width, height, } = this;
			return `0 0 ${ width } ${ height }`;
		},
	},
};
</script>

<style lang="scss" scoped></style>
